/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

export const EVENT_END_DELAY = 100;
export const DEFAULT_THROTTLE_RATE = 50;